export default () => ({
    title: null,
    isActive: true,
    isVisible: true,
    slug: null,
    isTrial: false,
    isSpecific: false,
    contactType: null,
    price: null,
    description: null,
    requirement: null,
})
